import { createContext, useContext } from "react";
import type { UseAIPlannerResult } from "./planner-session";

export const PlannerContext = createContext<UseAIPlannerResult | null>(null);

export function usePlannerContext(): UseAIPlannerResult {
  const ctx = useContext(PlannerContext);
  if (!ctx) {
    throw new Error("usePlannerContext must be used within PlannerProvider");
  }
  return ctx;
}
